export default __webpack_public_path__ + "static/media/star-icon.3527d32b.svg";